import {
  saveRevokeData,
  saveRollbackDataSingle,
  saveRevokeDataSingle,
  clearRollbackData,
} from "@/mixins/initRevokeData.js";
import store from "@/store/index";

//初始化组名
const groupNames = [
  "rlJoint",
  "rlGrid",
  "rlAxis",
  "rlBeamSeg",
  "rlColSeg",
  "rlRingBeamSeg",
  "rlSlab",
  "rlSlabHole",
  "rlSubBeam",
  "rlWallHole",
  "rlWallSeg",
];

// 初始化撤销重做数据
export const initRevokeReDoData = async () => {
  try {
    // 初始化数据对象
    let data = {
      id: "cacheObj",
      revokeArr: [{ init: [] }],
      rollbackArr: [],
    };

    // 保存撤销数据
    groupNames.forEach((groupName) => {
      let group = store.state.rlEntData.totalEntityData[groupName]; //rlAppObj.rlMxDatabase.getGroup(groupName)?.getAll();

      if (group && group.length > 0) {
        group.map((item) => {
          data.revokeArr[0]["init"].push(item.getDataBase());
        });
      }
    });

    store.commit("globalData/setRevokeRollbackLength", 0);
    store.commit("globalData/setRevokeDataLength", 1);
    store.commit("globalData/clearRawStep");
    // return "创建成功";
    // 保存撤销数据
    await saveRevokeData(data);
  } catch (error) {
    console.error("初始化撤销重做数据失败：", error);
  }
};

// 撤销操作
export const revokeRollback = async (obj, step, type) => {
  let newObj = obj;
  await AddRevoke(newObj, step, type);
  //新增操作时，清空回退数据
  await clearRollbackData();
};

// 新增撤销操作
export const AddRevoke = async (
  obj /*新增对象 */,
  step /*当前步数 */,
  type
) => {
  await saveRevokeDataSingle(step, type, obj.getDrawData());
};

// 回退操作
export const rollbackRevoke = async () => {
  await AddRollback();
};

// 新增回退操作
export const AddRollback = async () => {
  await saveRollbackDataSingle();
};
